"use strict";

window.addEventListener('load', () => {});
customElements.define('ec-cpm-cylindo', class extends HTMLElement {
  constructor() {
    super();
    this.viewerEl = null;
    this.thumbnailEl = null;
    this.handleFullscreen = this.handleFullscreen.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }
  connectedCallback() {
    this.viewerEl = this.querySelector('cylindo-viewer');
    if (!this.viewerEl) return;
    this.thumbnailEl = document.getElementById("cylindo-thumb");
    const sectionId = this.getAttribute('data-section-id')?.trim();
    if (sectionId) {
      document.addEventListener(`${sectionId}-completed`, this.handleUpdate);
      document.addEventListener(`${sectionId}-update`, this.handleUpdate);
    }
    this.viewerEl.addEventListener('fullscreen-change', this.handleFullscreen);
  }
  disconnectedCallback() {
    if (this.viewerEl) {
      this.viewerEl.removeEventListener('fullscreen-change', this.handleFullscreen);
    }
  }
  handleFullscreen(e) {
    this.classList.toggle('fullscreen', e.detail.isFullscreen);
  }
  handleUpdate(e) {
    if (!e.detail || !e.detail.state?.cylindo || !Object.keys(e.detail.state?.cylindo).length) return;
    const detail = e.detail;
    const featuresObj = detail.state.cylindo;
    const newCylindoId = detail.state?.variant?.custom?.default_cylindo_id?.trim() ?? window.shopify_product[0]?.default_cylindo_id?.trim();
    const configString = Object.entries(featuresObj).map(([key, value]) => `${key}:${value}`).join(',');
    requestAnimationFrame(() => {
      if (this.viewerEl) {
        this.viewerEl.setAttribute('configuration', configString.trim());
        if (!e.type.includes('update')) {
          if (newCylindoId && newCylindoId !== this.viewerEl.getAttribute('code')) {
            this.viewerEl.setAttribute('code', newCylindoId);
          }
        }
      }
    });
    if (this.thumbnailEl) {
      this.thumbnailEl.parentElement.classList.remove('hidden');
      const image = this.thumbnailEl.querySelector('img');
      if (image) {
        const src = image.getAttribute('src');
        const url = new URL(src);
        const baseUrl = `${url.origin}${url.pathname}`;
        const updatedPath = baseUrl.replace(/\/products\/\d+\//, `/products/${newCylindoId}/`);
        let newSrc = updatedPath;
        let separator = '?';
        for (const [key, value] of Object.entries(featuresObj)) {
          newSrc += `${separator}feature=${key}:${value}`;
          separator = '&';
        }
        const originalParams = new URLSearchParams(url.search);
        for (const [key, value] of originalParams) {
          if (key !== 'feature') {
            newSrc += `&${key}=${value}`;
          }
        }
        image.setAttribute('src', newSrc);
      }
    }
  }
});